require('./dist/select.js');
module.exports = 'ui.select';



//////////////////
// WEBPACK FOOTER
// ./~/ui-select/index.js
// module id = 203
// module chunks = 0